<div
  #tabBar
  class="tab-container"
  [class.absolute-mobile-tab-bar]="useAbsolutePositionScrolling"
  (scroll)="onScroll($event)">
  <ng-container *ngIf="!isLoading; else loading">
    <ng-container *ngFor="let tab of tabs; let tabIndex = index">
      <button class="no-style-button tab" (click)="onTabClicked(tabIndex)" [ngClass]="{ active: tab.active }">
        {{ tab.title }}
      </button>
    </ng-container>
  </ng-container>
</div>
<ng-container *ngIf="useAbsolutePositionScrolling">
  <div [style.opacity]="scrollFadeEndOpacity" class="mobile-scroll-gradient-end"></div>
  <div [style.opacity]="scrollFadeStartOpacity" class="mobile-scroll-gradient-start"></div>
  <div class="height-buffer" #buffer></div>
</ng-container>

<ng-template i18n #loading>
  <lib-loading-shimmer *appRepeat="6" [width]="'7.5rem'" [height]="'3rem'" />
</ng-template>
